import { unref } from 'vue';

/* v8 ignore file -- @preserve */
// Ignoring test coverage since jest doesn't work well with focus
// Taken from https://hidde.blog/using-javascript-to-trap-focus-in-an-element/
export function useFocusTrap(elementRef) {
  function trap(e) {
    if (e.key !== 'Tab') return;

    const el = unref(elementRef);
    if (!el) return;

    const focusableSelector =
      'a[href]:not([disabled],[tabindex="-1"]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), [tabindex="0"]';

    const focusableEls = Array.from(el.querySelectorAll(focusableSelector)).filter(
      (node) => node.offsetWidth > 0 || node.offsetHeight > 0 || node.getClientRects().length > 0,
    );

    if (focusableEls.length === 0) return;

    const firstFocusableEl = focusableEls[0];
    const lastFocusableEl = focusableEls[focusableEls.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else if (document.activeElement === lastFocusableEl) {
      firstFocusableEl.focus();
      e.preventDefault();
    }
  }

  let cleanup = () => {};

  function activate() {
    cleanup();
    const el = unref(elementRef);
    if (el) {
      el.addEventListener('keydown', trap);
      cleanup = () => el.removeEventListener('keydown', trap);
    }
  }

  function deactivate() {
    cleanup();
  }

  return { activate, deactivate };
}
